export function upsertInArray<T extends { id: number }>(array: T[] | null, item: T): T[] {
  if (!array) {
    return [item];
  }
  const existingIndex = array.findIndex((existing) => existing.id === item.id);
  if (existingIndex >= 0) {
    return array.map((existing, index) =>
      index === existingIndex ? { ...existing, ...item } : existing,
    );
  }
  return [...array, item];
}
